import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Text } from '@uhg-abyss/web/ui/Text';

export const StyledButton = styled(Button, {
  fontFamily: '$primary',
  fontSize: '16px !important',
  fontWeight: '590 !important',
  lineHeight: '20px !important',
  padding: '0 !important',
});

export const TextOnTopOfProgressBar = styled(Text, {
  fontWeight: 600,
  style: 'semibold',
  fontSize: '14px',
  lineHeight: '140%',
  letterSpacing: '0',
  verticalAlign: 'middle',
});

export const TotalCostOfCareContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  paddingLeft: 32,
});

export const TextOnBottomOfProgressBar = styled(Text, {
  fontWeight: 700,
  style: 'bold',
  fontSize: '16px',
  lineHeight: '140%',
  letterSpacing: '0',
  verticalAlign: 'middle',
});

export const MainProgressBarContainer = styled('div', {
  position: 'relative',
  height: 8,
  borderRadius: 8,
  overflow: 'hidden',
  display: 'flex',
  border: '0.5px solid #7D7F81',
});
